import React from 'react';
import ContactModal from "../ContactModal";

function Libre2() {

    return (
            <section className="libre layout-pt-50 layout-pb-100 text-center" style={{background: "#E7ECFF80"}}>
                <div className="auto-container">
                    <div className="text-center">
                        <h2 className="libre-title">
                            Pourquoi utiliser <span>ce service ?</span>
                        </h2>

                        <div className="text mt-15 mb-2">
                            Nos experts sont à votre écoute pour vous renseigner sur le handicap au travail, répondre à vos questions, vous offrir des conseils pratiques et vous orienter vers des solutions concrètes, que vous souhaitiez des réponses pour vous-même ou pour un proche. Notre hotline garantit un service confidentiel.
                        </div>
                        <div className="text mt-3 mb-4">
                            <b>Vos coordonnées ne seront jamais communiquées à votre employeur.</b>
                        </div>

                        <div className="text mt-15 fst-italic" style={{fontSize: "16px"}}>
                            <span>
                                <b>Exemples de questions posées :</b><br/>
                            Qui est concerné par le handicap ? C’est quoi la RQTH* ? Quels bénéfices la RQTH* peut-elle apporter à la personne concernée ?<br/>
                            De quels aménagements puis-je bénéficier ?
                            Comment en bénéficier? Comment obtenir la RQTH* ? Qui peut m’aider? A qui m’adresser?
                            </span>
                        </div>
                        <div className="text mt-15 fst-italic" style={{fontSize: "12px"}}>*<b>RQTH :</b> Reconnaissance
                            de la Qualité de Travailleur Handicapé
                        </div>

                    </div>

                    {/*<motion.button
                            className="theme-btn btn-style-one small"
                            initial={{opacity: 0, y: 0}}
                            animate={{opacity: 1, y: 20}}
                            transition={{delay: 1.0, duration: 1.5}}
                            data-cal-namespace="ligne-inclusion"
                            data-cal-link="team/talents-handicap/ligne-inclusion"
                            data-cal-config='{"layout":"month_view"}'
                    >Réserver mon créneau
                    </motion.button>*/}
                        <ContactModal textButton="Réserver un créneau" showText={false} small="small" linkPageContact={false} iframe={true} couleur={false} />
                    </div>
            </section>
);
}

export default Libre2;
